import { render, staticRenderFns } from "./feeDetailShopFeeRule.vue?vue&type=template&id=39cf04ba&scoped=true"
import script from "./feeDetailShopFeeRule.vue?vue&type=script&lang=js"
export * from "./feeDetailShopFeeRule.vue?vue&type=script&lang=js"
import style0 from "./feeDetailShopFeeRule.vue?vue&type=style&index=0&id=39cf04ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf04ba",
  null
  
)

export default component.exports